import { threeMemberTeamCompetitions } from '@lib/constants/competitions'

type Props = {
  title: string
  start: string
  end: string
  teamSize: string
  orgName: string
  orgWebsite: string
  orgLogo: string
  data?: any
}

export const EventCard = ({
  title,
  start,
  end,
  teamSize,
  orgName,
  orgWebsite,
  orgLogo,
  data,
}: Props): JSX.Element => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col lg:flex-row">
        <img
          src={orgLogo}
          className="h-32 w-32 object-contain p-2 mt-6 border text-grey-500 rounded bg-white"
          alt={orgName}
        />
        <div className="p-2 ml-6">
          <h1 className="font-600 py-2 text-3xl text-orange">{title}</h1>
          <div className="flex justify-between my-0 mr-2">
            <div className="text-grey flex">
              <p className="flex flex-1 whitespace-no-wrap mr-2">Hosted by</p>
              <a
                href={orgWebsite}
                target="_blank"
                rel="noreferrer noopener"
                className="font-600 text-grey hover:underline"
              >
                {orgName}
              </a>
            </div>
          </div>
          <p className="mt-10">
            <span className="text-grey-800">STARTS AT:</span>
            <span className="text-grey font-600 px-5">{start}</span>
          </p>
          <p className="my-6">
            <span className="text-grey-800">ENDS AT:</span>
            <span className="text-grey font-600 px-5">{end}</span>
          </p>
          <p className="my-6">
            <span className="text-grey-800">TEAM SIZE:</span>
            <span className="text-grey font-600 px-5 ">
              {threeMemberTeamCompetitions.includes(data.slug)
                ? 'Upto 3 members'
                : teamSize}
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default EventCard
